import { HttpClient } from '@angular/common/http';

import { Observable, empty } from 'rxjs';
import { map } from 'rxjs/operators';

import * as _ from 'lodash';

import { plainToClass, classToPlain } from 'class-transformer';
import { HistoryInterface } from '../history/history.interface';
import { HistoryModel } from '../history/history.model';

export class AbstractService<T> {

  constructor(public http: HttpClient, public path: string, public modelType: any) {
  }

  list(): Observable<T[]> {
    return this.http.get<T[]>(this.path).pipe(
      map(data => plainToClass(this.modelType, data))
    );
  }

  count(): Observable<number> {
    return this.http.get<any>(this.path + '/count').pipe(
      map(data => data.count)
    );
  }

  get(id: number): Observable<T> {
    return this.http.get<{ data: T, grants: string }>(`${this.path}/${id}`).pipe(
      map(data => plainToClass(this.modelType, data.data))
    );
  }

  getHistory(id: number): Observable<HistoryModel[]> {
    return this.http.get<HistoryInterface[]>(`${this.path}/${id}/history`).pipe(
      map(data => plainToClass(HistoryModel, data))
    );
  }

  update(data: T): Observable<T> {
    if (data && (data as any)._id) {
      return this.http.put<{ data: T, grants: string }>(`${this.path}/${(data as any)._id}`, classToPlain(data)).pipe(
        map(d => plainToClass(this.modelType, d.data))
      );
    } else {
      return empty();
    }
  }

  create(data: T): Observable<T> {
    return this.http.post<T>(this.path, classToPlain(data)).pipe(
      map(d => plainToClass(this.modelType, d))
    );
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.path}/${id}`);
  }

}
